/** Shared admin crypto pieces: screening badge/panel and long-identifier cells. */
import { Badge } from '@hopex/ui';
import { GATE_LABEL, SCREEN_RESULT, type ScreeningState } from '../../lib/crypto-model.ts';

export function ScreeningCell({ s }: { s: ScreeningState }) {
  const r = s.check ? SCREEN_RESULT[s.check.result] : null;
  return (
    <span className="flex flex-col items-start gap-0.5 text-[12px]" data-screening={s.state}>
      {r ? <Badge tone={r.tone}>{r.label}</Badge> : <Badge tone="negative">غربالگری نشده</Badge>}
      <span className="text-fg-subtle">{GATE_LABEL[s.state]}</span>
      {s.check && (
        <span className="text-fg-subtle">
          سیاست v{s.check.policyVersion}
          {s.check.decision ? ` · تصمیم: ${s.check.decision.decision}` : ''}
        </span>
      )}
    </span>
  );
}

export function LongId({ value, href }: { value: string | null; href?: string | null }) {
  if (!value) return <span className="text-fg-muted">—</span>;
  const short = value.length > 18 ? `${value.slice(0, 8)}…${value.slice(-8)}` : value;
  const inner = (
    <bdi dir="ltr" className="font-mono text-[12px]" title={value}>
      {short}
    </bdi>
  );
  return href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-accent-text hover:underline"
    >
      {inner}
    </a>
  ) : (
    inner
  );
}
